/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import DailyClosingSummaryRsvnSalesOta from './DailyClosingSummaryRsvnSalesOta'

/**
 * The DailyClosingSummaryRsvnSales model module.
 * @module model/DailyClosingSummaryRsvnSales
 * @version 1.0.0
 */
export default class DailyClosingSummaryRsvnSales {
  /**
   * Constructs a new <code>DailyClosingSummaryRsvnSales</code>.
   * @alias module:model/DailyClosingSummaryRsvnSales
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>DailyClosingSummaryRsvnSales</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DailyClosingSummaryRsvnSales} obj Optional instance to populate.
   * @return {module:model/DailyClosingSummaryRsvnSales} The populated <code>DailyClosingSummaryRsvnSales</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DailyClosingSummaryRsvnSales()

      if (data.hasOwnProperty('total')) {
        obj['total'] = ApiClient.convertToType(data['total'], 'Number')
      }
      if (data.hasOwnProperty('ota')) {
        obj['ota'] = ApiClient.convertToType(data['ota'], [DailyClosingSummaryRsvnSalesOta])
      }
    }
    return obj
  }

  /**
   * @member {Number} total
   */
  total = undefined
  /**
   * @member {Array.<module:model/DailyClosingSummaryRsvnSalesOta>} ota
   */
  ota = undefined
}
